var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import './Tooltip.styles.scss';
import { Popup } from '../Popup';
var Tooltip = function (_a) {
    var title = _a.title, placement = _a.placement, children = _a.children;
    var _b = useState(false), canShowTooltip = _b[0], setCanShowTooltip = _b[1];
    return (_jsx(Popup, __assign({ trigger: title !== '' ? ['hover', 'click'] : [], popupPlacement: placement !== null && placement !== void 0 ? placement : 'topLeft', popupVisible: canShowTooltip, onPopupVisibleChange: setCanShowTooltip, popup: _jsx("div", __assign({ className: "hefesto-tooltip", "aria-hidden": !canShowTooltip }, { children: _jsx("label", __assign({ className: "hefesto-tooltip__title", role: "tooltip" }, { children: title })) })) }, { children: children })));
};
export default Tooltip;
